import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteGuard } from "@/components/auth/RouteGuard";

export const Route = createFileRoute("/_authenticated/grns")({
  component: () => (
    <RouteGuard module="grns"><Outlet /></RouteGuard>
  ),
});
